/**
 * @ngdoc directive
 * @name flowHistoryStart
 * @module flowingly.runner.flow
 * @description  This comppnent is used to display information about when the flow was started.
 * @usage
 * ```
     <flow-history-start flow="$ctrl.flow" is-mobile="$ctrl.isMobile"></flow-history-start>
 * ``` 
 * ### Notes
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Angular+Flow+Components
 * ### Properties
 * #### Inputs
 * * flow: the flow data to display
 * * isMobile: show mobile view if set
 */
import IFormattedFlow from '@Client/interfaces/IFormattedFlow';
import { SharedAngular } from '@Shared.FormGen/angular-form-gen/@types/sharedAngular';
import angular from 'angular';

class FlowHistorytartController {
  public static $inject = [
    'runnerFlowsFormatter',
    '$location',
    'flowinglyMomentService',
    'sessionService'
  ];
  public flow: IFormattedFlow;
  public isMobile;
  public startedMessage: string;
  public startedHeader: string;
  public versionMessage: string;

  constructor(
    private runnerFlowsFormatter: RunnerFlowsFormatterService,
    private $location: angular.ILocationService,
    private flowinglyMomentService: SharedAngular.FlowinglyMomentService,
    private sessionService: SharedAngular.SessionService
  ) {}

  $onInit() {
    this.startedMessage = this.runnerFlowsFormatter.getStartedByText(
      this.flow,
      true
    );
    const isTestFlow = this.$location.search().isTestFlow === 'true';
    this.startedHeader = isTestFlow ? 'Test flow started' : 'Flow started';

    const user = this.sessionService.getUser();
    const updatedByUserName =
      user.id === this.flow.schemaUpdatedByUserId
        ? 'You'
        : this.flow.schemaUpdatedByFullName;
    this.versionMessage = isTestFlow
      ? `${
          this.flow.name
        }, updated by ${updatedByUserName}, ${this.flowinglyMomentService.formatFullDate(
          this.flow.schemaUpdatedUtc,
          'LLL'
        )}`
      : `${this.flow.name}, version: V.${this.flow.flowVersionNumber}`;
  }
}
class FlowHistorytartComponent implements angular.IComponentOptions {
  public bindings = {
    flow: '<',
    isMobile: '<' //show mobile view if set
  };
  public template = `
    <div ng-if="$ctrl.flow.flowId != '00000000-0000-0000-0000-000000000000'" class="flow-history-start" ng-class="{'isMobile': $ctrl.isMobile}">    
        <div class="avatar-container">
            <div class="avatar"><flow-avatar-circle name="$ctrl.flow.startedByName" avatar-url="$ctrl.flow.startedByUserAvatarUrl"></flow-avatar-circle></div>
        </div>

        <div class ="text single-flow-view__contents" ng-class ="{'mt-10': !$ctrl.isMobile}">
            <p><b>{{ $ctrl.startedHeader }}</b></p>
            <p class ="secondary-text">{{ $ctrl.startedMessage }}</p>
            <p class ="secondary-text cc-users" ng-if="$ctrl.flow.ccUsers.length > 0">CC'd to: {{$ctrl.flow.ccUsers}}</p>
            <p class ="secondary-text flow-version-info">{{$ctrl.versionMessage}}</p>
            <p class ="secondary-text pb-15"></p>
        </div>
    </div>`;
  public controller = FlowHistorytartController;
}

angular
  .module('flowingly.runner.flow')
  .component('flowHistoryStart', new FlowHistorytartComponent());
